import { watch } from 'vue'

import { useAuthStore } from '@/auth/useAuthStore'

import { useBrazeStore } from './useBrazeStore'

export const useBrazeLifecycle = (): void => {
  const authStore = useAuthStore()
  const brazeStore = useBrazeStore()

  // Whether Braze is enabled is decided server-side by the token endpoint (the
  // single evaluation point), not a client-read flag — so the lifecycle only
  // tracks the auth precondition: init on login, tear down on logout.
  // initializeBraze silently no-ops if the backend reports Braze is off.
  watch(
    (): string | undefined => authStore.user?.id,
    (userId) => {
      if (!userId) {
        brazeStore.shutdownBraze()
        return
      }
      void brazeStore.initializeBraze()
    },
    { immediate: true }
  )
}
